// @ts-nocheck
export { createClient } from './createClient';
export { generateGraphqlOperation } from './generateGraphqlOperation';
export { linkTypeMap } from './linkTypeMap';
// export { Observable } from 'zen-observable-ts'
export { createFetcher } from './fetcher';
export { GenqlError } from './error';
export var everything = {
    __scalar: true,
};
